import { Link } from "react-router-dom";
import { MapPin, Users } from "lucide-react";
import { CATEGORY_LABELS, formatDate, priceLabel } from "@/lib/api";
import Stars from "@/components/Stars";

export default function EveningCard({ evening, index = 0 }) {
  const left = evening.seats_available;
  return (
    <Link
      to={`/evenings/${evening.id}`}
      data-testid={`evening-card-${evening.id}`}
      className="card-parchment group flex flex-col overflow-hidden"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={evening.image}
          alt={evening.venue_name}
          className="img-duotone h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-velvet/60 via-transparent to-transparent" />
        <span className="absolute top-3 left-3 bg-wine text-parchment text-[0.65rem] uppercase tracking-[0.2em] px-3 py-1">
          {CATEGORY_LABELS[evening.category] || evening.category}
        </span>
        {evening.sold_out ? (
          <span data-testid={`sold-out-${evening.id}`} className="absolute top-3 right-3 bg-velvet/90 text-gold text-[0.65rem] uppercase tracking-[0.2em] px-3 py-1">
            Complet
          </span>
        ) : evening.price === 0 ? (
          <span className="absolute top-3 right-3 bg-gold text-wine-dark text-[0.65rem] uppercase tracking-[0.2em] px-3 py-1 font-medium">
            Accès libre
          </span>
        ) : null}
      </div>

      <div className="p-5 flex flex-col flex-1">
        <div className="eyebrow mb-2">{formatDate(evening.date)}</div>
        <h3 className="font-serif text-2xl text-ink leading-tight mb-1">{evening.title}</h3>
        <p className="text-sm text-ink-muted mb-2">{evening.venue_name}</p>
        {evening.review_count > 0 && (
          <div className="flex items-center gap-2 mb-2" data-testid={`card-rating-${evening.id}`}>
            <Stars value={evening.avg_rating} size={13} />
            <span className="text-xs text-stone">{evening.avg_rating} · {evening.review_count}</span>
          </div>
        )}

        <div className="mt-auto flex items-center justify-between text-xs text-stone pt-4 border-t border-stone-border/60">
          <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-gold" />{evening.city}</span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1.5">
              <Users className="w-3.5 h-3.5 text-gold" />
              {left > 0 ? `${left} left` : "Full"}
            </span>
            <span className="text-ink-muted font-medium">{priceLabel(evening.price)}</span>
          </span>
        </div>
      </div>
    </Link>
  );
}
